import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { CustomerWallet } from 'types/customers'
import { TransactionExportModal } from './TransactionExportModal'

interface TransactionExportProps {
  downloadAll?: boolean
  customerWallet?: CustomerWallet
}

export const TransactionExport = ({ downloadAll, customerWallet }: TransactionExportProps) => {
  const { t } = useTranslation()

  const [showCustomDateExportModal, setShowCustomDateExportModal] = useState(false)

  const btnTxt = downloadAll ? t('walletsPage.exportTransactionsBtnText') : t('walletsPage.export')

  const handleClose = () => {
    setShowCustomDateExportModal(false)
  }

  return (
    <>
      {showCustomDateExportModal && (
        <TransactionExportModal
          handleClose={handleClose}
          downloadAll={downloadAll}
          customerWallet={customerWallet}
        />
      )}
      <Button
        variant="secondary"
        iconElement={<Icon name="DownloadSimple" />}
        onClick={() => setShowCustomDateExportModal(true)}
        testId="export-wallet-transactions-btn"
      >
        {btnTxt}
      </Button>
    </>
  )
}
